(function() {
	'use strict';

	// user selector template
	var userSelectorTemplateUrl = require('../userSelectorDialog/userSelectorDialog.template');

	angular.module('smb-app')
		.directive('smbContentTypeGroupConfigForm', ContentTypeGroupConfigFormDirective)
		.controller('smbContentTypeGroupConfigFormController',[
			'$scope',
			'$mdDialog',
			'sbToastService',
			'smbIconDataStore',
			'smbUserGroupsDataStore',
			ContentTypeGroupConfigFormController
		]);

	var templateUrl = require('./contentTypeGroupConfigForm.template');
	function ContentTypeGroupConfigFormDirective() {
		return {
			restrict: 'E',
			controller: 'smbContentTypeGroupConfigFormController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				group: '=',
				viewRightsUserGroups: '=',
				fullRightsUserGroups: '=',
				editRightsUserGroups: '=',
				onChange: '&'
			}
		};
	}

	function ContentTypeGroupConfigFormController($scope, $mdDialog, sbToastService, smbIconDataStore, smbUserGroupsDataStore) {
		var vm = this;
		vm.isLoading = false;
		// Icon configuration
		vm.groupIcon = null;

		vm.onNameBlur = onNameBlur;
		vm.addUserGroup = addUserGroup;
		vm.addUserGroups = addUserGroups;
		vm.removeUserGroup = removeUserGroup;
		vm.setIcon = setIcon;

		var groupName = '';
		(function initContentTypeGroupConfigFormController() {
			vm.isLoading = true;
			smbIconDataStore.loadIcons()
			.then(function() {
				$scope.$watch('vm.group', function() {
					if (vm.group) {
						vm.groupIcon = smbIconDataStore.icons.find(function(icon) { return icon.IconUserFriendlyName === vm.group.IconName; });
						groupName = vm.group.LibraryName;
					}
				});
			})
			.then(function() {
				return smbUserGroupsDataStore.getUserGroups();
			})
			.finally(function() { vm.isLoading = false; });
		}());

		function addUserGroups(event, target, removeTarget) {
			var groupUserGroups = target;
			var newGroups = smbUserGroupsDataStore.userGroups.filter(function (group) {

				for (var x = 0; x < groupUserGroups.length; x++) {
					if (groupUserGroups[x].UserGroupId === group.UserGroupId) {
						return false;
					}
				}
				return true;
			});

			$mdDialog.show({
				controller: 'smbUserSelectorController',
				controllerAs: 'vm',
				templateUrl: userSelectorTemplateUrl,
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					users: newGroups,
					multiSelect: true
				}
			})
			.then(function (selectedUserGroups) {
				//new user groups
				selectedUserGroups.forEach(function(group) {
					target.push(group);
					// If the user group exists in another access rights array, it should
					// only be in one, use this flag to prevent iterating over
					// subsequent arrays when we know it is not necessary to do so.
					// Doing this because I can't think of a better way that scales and
					// this is n cubed.
					var removed = false;
					removeTarget.forEach(function(target) {
						if (!removed) {
							var g = target.find(function(ug) {
								return ug.UserGroupId === group.UserGroupId;
							});
							if (g) {
								target.splice(target.indexOf(g), 1);
								removed = true;
							}
						}
					});
				});
				emitChange();
			}, function () {
				//cancel
			});
		}

		function removeUserGroup(group, target) {
			var index = target.indexOf(group);
			if (index === -1) { return; }

			target.splice(index, 1);
			emitChange();
		}

		function setIcon(event) {
			$mdDialog.show({
				controller: 'smbUserSelectorController',
				controllerAs: 'vm',
				templateUrl: userSelectorTemplateUrl,
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					users: smbIconDataStore.icons,
					multiSelect: false
				}
			})
			.then(function (icon) {
				if (icon.length === 1) {
					vm.group.IconName = icon[0].IconUserFriendlyName;
					vm.group.IconId = icon[0].IconId;
					if (!vm.group.Links) {
						vm.group.Links = {};
					}
					vm.group.Links.IconUri = icon[0].IconUri;
					vm.onChange({ group: vm.group, viewUserGroups: vm.viewRightsUserGroups, fullUserGroups: vm.fullRightsUserGroups });
				}
			}, function () {
				//cancel
			});
		}

		function addUserGroup() {
			emitChange();
		}

		function onNameBlur() {
			if (vm.group.LibraryName !== groupName) {
				emitChange();
			}
		}

		function emitChange() {
			vm.onChange({group: vm.group, viewUserGroups: vm.viewRightsUserGroups, fullUserGroups: vm.fullRightsUserGroups});
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupConfigForm/contentTypeGroupConfigForm.js
// module id = 69
// module chunks = 1